import { render } from "./sidebar.html?vue&type=template&id=45c47608&scoped=true&external"
import script from "./sidebar.js?vue&type=script&lang=js&external"
export * from "./sidebar.js?vue&type=script&lang=js&external"

import "./SidebarComponent.vue?vue&type=style&index=0&id=45c47608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c47608"]])

export default __exports__